module.exports = __webpack_public_path__ + "static/media/IMG_3505_sm.0f2092b1.jpg";